import { getProcessTaskCore } from './process-task-core';
import { getProcedureTaskCore } from './procedure-task-core';
export function getTaskCore(task) {
    return task.template.assigned_object.content_type === 'procedure'
        ? getProcedureTaskCore(task)
        : getProcessTaskCore(task);
}
